import {useEffect, useState} from "react";
import Swal from "sweetalert2";
import {Ajax} from "../../Service/ajax";
import './customDropdown.css';
import {useLocation, useNavigate} from "react-router-dom";
import {hosts, security} from "../../env/Environment";
import { CircleLoader } from "react-spinners";
import withReactContent from 'sweetalert2-react-content';

export default function TableParticular({ title, content, onUpdateSubscriptions }) {
    const [subscriptions, setSubscriptions] = useState(content);
    const MySwal = withReactContent(Swal);

    const navigate = useNavigate();
    const location = useLocation();
    const session = sessionStorage.getItem("session");
    const url = window.location.pathname + window.location.search;
    const [prefix, setPrefix] = useState("243");
    const [suffix, setSuffix] = useState("");
    const [account, setAccount] = useState("");
    const [full_name, setFull_name] = useState("");
    const [expiration_date, setExpiration_date] = useState("");
    const [control, setControl] = useState("");
    const [providerInput, setProviderInput] = useState('Netikash Pay');
    const [provider, setProvider] = useState({})
    const [providers, setProviders]=useState([]);
    const[ref, setRef] = useState("");
    const[cnlUrl, setCnlUrl] = useState("");
    const [cfrmUrl, setCfrmUrl] = useState("");
    const [loading, setLoading] = useState(false);
    const continue_url=window.location.origin+"/payment-check?trs="+ref;
    const [isValidAccount, setIsValidAccount] = useState(false);
    const [providerLogo, setProviderLogo] = useState([
        { name: "Netikash Pay", logo: require("../../assets/img/Providers/netikash-pay-logo.jpg") },
        { name: "Orange Money", logo: require("../../assets/img/Providers/orange-money-logo.png") },
        { name: "Airtel Money", logo: require("../../assets/img/Providers/airtel-money-logo.png") },
        { name: "Afri Money", logo: require("../../assets/img/Providers/afrimoney-logo.png") },
        { name: "M Pesa", logo: require("../../assets/img/Providers/mpesa-logo.png") }
    ]);
    const [subPlan, setSubPlan] = useState({
        'organisationId':"",
        'price':0,
        'devise':"CDF",
        'title':"",
    });

    const callbackUrlRqsModel = {
        continue_url: continue_url,
        callback_url: cfrmUrl
    };

    const transactorRqsModel = {
        provider_id: provider.id,
        prefix: prefix,
        account: account,
        suffix: suffix,
        full_name: full_name,
        expiration_date: expiration_date,
        control: control
    };

    const paymentRqsModel = {
        company_id: subPlan.organisationId,
        password: null,
        app_id: security.app_id,
        client_id: security.client_id,
        currency: subPlan.devise,
        ref: ref,
        label: "souscription a l'abonnement "+subPlan.title,
        amount: subPlan.price,
        callbackUrl: callbackUrlRqsModel,
        buyer: transactorRqsModel
    };

    function showInfos(id) {
        const subscription = subscriptions.find(sub => sub.id === id);
        if (subscription) {
            Swal.fire({
                title: subscription.name,
                html: `
                    <div  style="text-align: left">
                        <p><strong>Abonnement:</strong> ${subscription.subscription}</p>
                        <p><strong>Prix:</strong> ${subscription.price}</p>
                        <p><strong>Périodicité:</strong> ${subscription.periodicity}</p>
                        <p><strong>Date souscription:</strong> ${subscription.start_time}</p>
                        <p><strong>Date expiration:</strong> ${subscription.end_time}</p>
                        <p><strong>Status:</strong> <span class="badge bg-label-success">${subscription.status}</span></p>
                     
                    </div>
                `,
                confirmButtonText: 'OK',
                customClass: {
                    popup: 'custom-popup',
                    confirmButton: 'custom-button'
                },
            });
        }
    }

    async function handleCancelled(id) {
        Swal.fire({
            title: 'Message important',
            text: "Etes vous sûr de vouloir vous désabonner à ce service !",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor:'#debf66',
            focusConfirm:true,
            confirmButtonText: 'Oui',
            cancelButtonText:'Non'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const {data} = await Ajax.putRequest(`/api/v1/sub/subscription/unsubscribe/${id}`);
                    if (data.error) {
                        Swal.fire({
                            title: 'Error!',
                            text: data.message,
                            icon: 'error',
                            confirmButtonText: 'OK',
                            customClass: {
                                popup: 'custom-popup',
                                confirmButton: 'custom-button'
                            },
                            timer: 5000
                        });
                    } else {
                        const subscription = subscriptions.find(sub => sub.id === id);
                        if (subscription.status === 'ACTIVE') {

                            setSubscriptions(prevSubscriptions =>
                                prevSubscriptions.map(subscription =>
                                    subscription.id === id ? {...subscription, status: 'CANCELED'} : subscription
                                )
                            );

                            onUpdateSubscriptions(subscriptions.filter(sub => sub.status === 'ACTIVE').length - 1, subscriptions.filter(sub => sub.status === 'EXPIRED').length, subscriptions.filter(sub => sub.status === 'CANCELED').length + 1);
                        }

                        Swal.fire({
                            title: 'Success!',
                            text: 'Désabonnement au service avec succès',
                            icon: 'success',
                            confirmButtonText: 'OK',
                            customClass: {
                                popup: 'custom-popup',
                                confirmButton: 'custom-button'
                            },
                            timer: 5000
                        });
                    }
                } catch (error) {
                    Swal.fire({
                        title: 'Error!',
                        text:`Oups! Une erreur s'est produite, veuillez reesayer plus tard.`,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        customClass: {
                            popup: 'custom-popup',
                            confirmButton: 'custom-button'
                        },
                        timer: 5000
                    });
                }
            }
        })
    }

    const getProviderLogo = (name) => {
        const provider = providerLogo.find(provider => provider.name === name);
        return provider ? provider.logo : '';
    };

    const handleSubmit = (payment) => {
        const fetchData = async () => {

            try {
                console.log(payment)
                const {data} = await Ajax.postRequest("/api/v1/sub/make", payment);
                if(!data.error){
                    if(data.payment_link){
                        window.location.replace(data.payment_link);
                    }else{
                        Swal.fire({
                            title: 'Success !',
                            text: "Votre réabonnement a été initié avec succès. Veuillez patienter pour recevoir le USSD de votre opérateur afin de finaliser l’opération.",
                            icon: 'success',
                            confirmButtonText: 'OK',
                            customClass: {
                                popup: 'custom-popup',
                                confirmButton: 'custom-button'
                            },
                            timer: 5000
                        });
                    }
                }else{
                    Swal.fire({
                        title: 'Error!',
                        text: data.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        customClass: {
                            popup: 'custom-popup',
                            confirmButton: 'custom-button'
                        },
                        timer: 5000
                    });
                }
            } catch (error) {
                Swal.fire({
                    title: 'Error!',
                    text:`Oups! Une erreur s'est produite, veuillez reesayer plus tard.`,
                    icon: 'error',
                    confirmButtonText: 'OK',
                    customClass: {
                        popup: 'custom-popup',
                        confirmButton: 'custom-button'
                    },
                    timer: 5000
                });
            }
        };
        fetchData();
    }

    const getProviderDetails = (name) => {
        return providers.find(provider => provider.name === name);
    };
    const handleRenew = async (id) => {
        setLoading(true);

        const subscription = subscriptions.find(sub => sub.id === id);
        const statusClass = subscription.status === 'ACTIVE' ? 'badge bg-label-success' : 'badge bg-label-danger';

        const optionsHtml = providers.map(provider => {
            const logo = getProviderLogo(provider.name);
            return `
                <span class="custom-option" data-value="${provider.name}">
                    <img src="${logo}" alt="${provider.name}" class="option-icon"/> ${provider.name}
                </span>
            `;
        }).join('');

        MySwal.fire({
            title: 'Chargement en cours...',
            html: '<div class="loading-spinner"><GridLoader color="#debf66" loading={true} size={15} /></div>',
            allowOutsideClick: false,
            showConfirmButton: false,
            didOpen: async () => {
                try {
                    const resp = await Ajax.getRequest(`/api/v1/sub/subscription/user/retrieve`);
                    const data= resp.data.object.find(sub => sub.id === id);
                    if(data.price <= 0 ){
                        try {
                            const { data } = await Ajax.putRequest(`/api/v1/sub/subscription/renew/${id}`);
                            if(data.error){
                                MySwal.update({
                                    icon:`success`,
                                    title: `Reabonnement Success!`,
                                    html:`<p>${data.message}</p>`,
                                    showConfirmButton: true,
                                    confirmButtonText: 'OK',
                                    timer: 5000
                                });
                            }else{
                                const subscription = subscriptions.find(sub => sub.id === id);
                                if (subscription.status === 'EXPIRED') {

                                    setSubscriptions(prevSubscriptions =>
                                        prevSubscriptions.map(subscription =>
                                            subscription.id === id ? { ...subscription, status: 'ACTIVE' } : subscription
                                        )
                                    );

                                    onUpdateSubscriptions(subscriptions.filter(sub => sub.status === 'ACTIVE').length + 1, subscriptions.filter(sub => sub.status === 'EXPIRED').length - 1, subscriptions.filter(sub => sub.status === 'CANCELED').length);
                                }else {

                                    setSubscriptions(prevSubscriptions =>
                                        prevSubscriptions.map(subscription =>
                                            subscription.id === id ? { ...subscription, status: 'ACTIVE' } : subscription
                                        )
                                    );

                                    onUpdateSubscriptions(subscriptions.filter(sub => sub.status === 'ACTIVE').length + 1, subscriptions.filter(sub => sub.status === 'EXPIRED').length, subscriptions.filter(sub => sub.status === 'CANCELED').length - 1);
                                }

                                MySwal.update({
                                    icon:`success`,
                                    title: `Reabonnement Success!`,
                                    html:`<p>Renouvellement d'abonnement effectué avec succès</p>`,
                                    showConfirmButton: true,
                                    confirmButtonText: 'OK',
                                    timer: 5000
                                });
                            }
                        } catch (error) {
                            // Gestion des erreurs
                            console.error(error);
                        }finally {
                            setLoading(false);
                        }

                    }else{
                        const dataInitPmt={
                            sub_id:data.subscriptionPlan.id,
                            infos:[]
                        }
                        const initPmt = await Ajax.postRequest("/api/v1/sub/subscription/initiate", dataInitPmt);
                        if(!initPmt.data.error){
                            MySwal.update({
                                icon:`info`,
                                title: `Reabonnement`,
                                html: `
                            <div style="height: 400px">
                                <div style="text-align: left">
                                    <p><strong>Abonnement:</strong> ${subscription.subscription}</p>
                                    <p><strong>Prix:</strong> ${subscription.price}</p>
                                    <p><strong>Périodicité:</strong> ${subscription.periodicity}</p>
                                    <p><strong>Status:</strong> <span class="${statusClass}">${subscription.status}</span></p>
                                </div>
                                <div>
                                    <p>Choisissez le moyen de paiement qui vous convient pour renouveler votre abonnement</p>
                                </div>
                                <div style="margin-top: 10px;">
                                    <div class="custom-select-wrapper">
                                        <div class="custom-select">
                                            <div class="custom-select-trigger">
                                                <span class="default-text">Sélectionner un moyen de paiement</span>
                                            </div>
                                            <div class="custom-options">
                                                ${optionsHtml}
                                            </div>
                                        </div>
                                    </div>
                                    <div id="validation-message" style="color: red; display: none;">Le format du numéro est incorrect ou le champ est vide</div>
                                    <div id="dynamic-inputs"></div>
                                </div>
                            </div>
                        `,
                                showConfirmButton: true,
                                confirmButtonText: 'Confirmer',
                                cancelButtonText: 'Annuler',
                                showCancelButton: true,
                                preConfirm: () => {
                                    const selectedProviderElement = document.querySelector('.custom-option.selected');
                                    const selectedProviderName = selectedProviderElement?.getAttribute('data-value');
                                    const selectedProviderDetails = getProviderDetails(selectedProviderName);
                                    const accountInfo = document.getElementById('account-info')?.value;

                                    const transactorRqsModel = {
                                        provider_id: selectedProviderDetails.id,
                                        prefix: "",
                                        account: "",
                                        suffix: "",
                                        full_name: "",
                                        expiration_date: "",
                                        control: ""
                                    };

                                    if (selectedProviderDetails && accountInfo) {
                                        const regex = new RegExp(selectedProviderDetails.account_format);
                                        if (!accountInfo || !regex.test(accountInfo)) {
                                            document.getElementById('validation-message').style.display = 'block';
                                            return false; // Prevent Swal from closing
                                        } else {
                                            document.getElementById('validation-message').style.display = 'none';
                                            // Handle the form data here (store in state or send to backend)
                                            setProviderInput(selectedProviderDetails.id);
                                            setAccount(accountInfo);
                                            transactorRqsModel.account = accountInfo;
                                            transactorRqsModel.prefix = '243';

                                            // if (selectedProviderDetails.with_prefix) {
                                            //     const prefixValue = document.getElementById('prefix-info')?.value;
                                            //     transactorRqsModel.prefix = prefixValue;
                                            //     setPrefix(prefixValue);
                                            // }
                                            if (selectedProviderDetails.with_suffix) {
                                                const suffixValue = document.getElementById('suffix-info')?.value;
                                                transactorRqsModel.suffix = suffixValue;
                                                setSuffix(suffixValue);
                                            }
                                            if (selectedProviderDetails.with_expiration_date) {
                                                const expirationDateValue = document.getElementById('expiration-date')?.value;
                                                transactorRqsModel.expirationDate = expirationDateValue;
                                                setExpiration_date(expirationDateValue);
                                            }
                                            if (selectedProviderDetails.with_control) {
                                                const controlValue = document.getElementById('control-info')?.value;
                                                transactorRqsModel.control = controlValue;
                                                setControl(controlValue);
                                            }
                                            if (selectedProviderDetails.with_full_name) {
                                                const fullNameValue = document.getElementById('full-name')?.value;
                                                transactorRqsModel.fullName = fullNameValue;
                                                setFull_name(fullNameValue);
                                            }

                                            const callbackUrlRqsModel = {
                                                continue_url: window.location.origin+"/payment-check?trs="+initPmt.data.object.pmt_id,
                                                callback_url: hosts.api+"/exposed/v1/sub/renew/"+id+"/trans-callback",
                                            };

                                            const paymentRqsModel = {
                                                company_id: data.subscriptionPlan.application.organisationId,
                                                password: null,
                                                app_id: security.app_id,
                                                client_id: security.client_id,
                                                currency: data.subscriptionPlan.devise,
                                                ref: initPmt.data.object.pmt_id,
                                                label: "souscription a l'abonnement "+data.subscriptionPlan.title,
                                                amount: data.subscriptionPlan.price,
                                                callbackUrl: callbackUrlRqsModel,
                                                buyer: transactorRqsModel
                                            };

                                            handleSubmit(paymentRqsModel);


                                            return true; // Allow Swal to close
                                        }
                                    } else {
                                        document.getElementById('validation-message').style.display = 'block';
                                        return false;
                                    }
                                }
                            });
                            document.querySelector('.custom-select-wrapper').addEventListener('click', function() {
                                this.querySelector('.custom-select').classList.toggle('open');
                            });
                            for (const option of document.querySelectorAll(".custom-option")) {
                                option.addEventListener('click', function() {
                                    if (!this.classList.contains('selected')) {
                                        this.parentNode.querySelector('.custom-option.selected')?.classList.remove('selected');
                                        this.classList.add('selected');
                                        const selectedProviderName = this.getAttribute('data-value');
                                        const selectedProviderLogo = getProviderLogo(selectedProviderName);
                                        const selectedProviderDetails = getProviderDetails(selectedProviderName);
                                        console.log('Selected Provider Details:', selectedProviderDetails);
                                        this.closest('.custom-select').querySelector('.custom-select-trigger').innerHTML = `
                                    <img src="${selectedProviderLogo}" alt="${selectedProviderName}" class="option-icon"/> ${selectedProviderName}
                                `;

                                        let dynamicInputsHtml = '';
                                        if (selectedProviderDetails.with_account) {
                                            dynamicInputsHtml += `<input id="account-info" placeholder="${selectedProviderDetails.account_label}" style="width: 100%; padding: 8px; border-radius: 4px; margin-top: 10px"/>`;
                                        }
                                        if (selectedProviderDetails.with_suffix) {
                                            dynamicInputsHtml += `<input id="suffix-info" placeholder="Suffixe" style="width: 100%; padding: 8px; border-radius: 4px; margin-top: 10px"/>`;
                                        }
                                        // if (selectedProviderDetails.with_prefix) {
                                        //     dynamicInputsHtml += `<input id="prefix-info" placeholder="Préfixe" style="width: 100%; padding: 8px; border-radius: 4px; margin-top: 10px"/>`;
                                        // }
                                        if (selectedProviderDetails.with_expiration_date) {
                                            dynamicInputsHtml += `<input type="date" id="expiration-date" placeholder="Date d'expiration" style="width: 100%; padding: 8px; border-radius: 4px; margin-top: 10px"/>`;
                                        }
                                        if (selectedProviderDetails.with_control) {
                                            dynamicInputsHtml += `<input id="control-info" placeholder="Numéro de contrôle" style="width: 100%; padding: 8px; border-radius: 4px; margin-top: 10px"/>`;
                                        }
                                        if (selectedProviderDetails.with_full_name) {
                                            dynamicInputsHtml += `<input id="full-name" placeholder="Nom complet" style="width: 100%; padding: 8px; border-radius: 4px; margin-top: 10px"/>`;
                                        }
                                        document.getElementById('dynamic-inputs').innerHTML = dynamicInputsHtml;
                                    }
                                });
                            }
                        }else{
                            MySwal.update({
                                icon:`error`,
                                title: `Reabonnement`,
                                html:`<p>${initPmt.data.message}</p>`,
                                showConfirmButton: true,
                                confirmButtonText: 'OK',
                            });
                        }
                        setSubPlan(data.subscriptionPlan);
                        setLoading(false);
                    }

                } catch (error) {
                    console.error('Error fetching data:', error);
                    MySwal.fire({
                        icon: 'error',
                        title: 'Erreur',
                        text: 'Impossible de charger les données. Veuillez réessayer.',
                        confirmButtonText: 'OK'
                    });
                }
            },
            willClose: () => {
                setLoading(false);
            }
        });
    };

    useEffect(() => {

        const fetchProvider = async () => {

            try {
                const {data} = await Ajax.getRequest("/api/v1/trs/providers", {params: {pge: 1, typ:"all", opr: "all", lmt: 100, slug: ""}});
                setProviders(data.contents)
            } catch (error) {
                console.log(error.message)
            }
        }
        fetchProvider();
    }, []);
    const isEmpty = content.length === 0;
    return (
        <div>
            <h5 className="card-header">{title}</h5>
            <div className="table-responsive text-nowrap">
                {isEmpty ? (
                    <p className="text-center">Aucun abonnement disponible</p>
                ) : (
                    <table className="table table-hover mb-5">
                        {/* Tableau des en-têtes */}
                        <thead>
                        <tr>
                            <th>Nom</th>
                            <th>Abonnement</th>
                            <th>Prix</th>
                            <th>Périodicité</th>
                            <th>Date souscription</th>
                            <th>Date expiration</th>
                            <th>Status</th>
                            <th>Action</th>
                        </tr>
                        </thead>
                        {/* Corps du tableau */}
                        <tbody className="table-border-bottom-0">
                        {subscriptions.map((item, index) => (
                            <tr key={index}>
                                {/* Colonnes de données */}
                                <td>{item.name}</td>
                                <td>{item.subscription}</td>
                                <td>{item.price}</td>
                                <td>{item.periodicity}</td>
                                <td>{item.start_time}</td>
                                <td>{item.end_time}</td>
                                <td>
                                    {/* Badge de statut */}
                                    {item.status === 'ACTIVE' && (
                                        <span className="badge bg-label-success">{item.status}</span>
                                    )}
                                    {item.status === 'EXPIRED' && (
                                        <span className="badge bg-label-warning">{item.status}</span>
                                    )}
                                    {item.status === 'CANCELED' && (
                                        <span className="badge bg-label-danger">{item.status}</span>
                                    )}
                                </td>
                                {/* Actions */}
                                <td>
                                    <div className="dropdown">
                                        <div className="btn-group" role="group" aria-label="Third group">
                                            {item.status === 'ACTIVE' && (
                                                <button type="button" className="btn btn-outline-netikash"
                                                        data-bs-toggle="tooltip"
                                                        data-bs-offset="0,8" data-bs-placement="top"
                                                        data-bs-custom-class="tooltip-dark" title="Annuler Abonnement"
                                                        onClick={() => handleCancelled(item.id)}>
                                                    <i className="bx bxs-stopwatch me-1"></i>
                                                </button>
                                            )}
                                            {item.status === 'EXPIRED' && (
                                                <button type="button" className="btn btn-outline-netikash"
                                                        data-bs-toggle="tooltip"
                                                        data-bs-offset="0,8" data-bs-placement="top"
                                                        data-bs-custom-class="tooltip-dark"
                                                        title="Renouveler abonnement"
                                                        onClick={() => handleRenew(item.id)}>
                                                    <i className="bx bx-revision me-1"></i>
                                                </button>
                                            )}
                                            {item.status === 'CANCELED' && (
                                                <button type="button" className="btn btn-outline-netikash"
                                                        data-bs-toggle="tooltip"
                                                        data-bs-offset="0,8" data-bs-placement="top"
                                                        data-bs-custom-class="tooltip-dark" title="Se Réabonner"
                                                        onClick={() => handleRenew(item.id)}>
                                                    <i className="bx bx-revision  me-1"></i>
                                                </button>
                                            )}
                                            <button type="button" className="btn btn-outline-netikash"
                                                    data-bs-toggle="tooltip"
                                                    data-bs-offset="0,8" data-bs-placement="top"
                                                    data-bs-custom-class="tooltip-dark" title="Détails"
                                                    onClick={() => showInfos(item.id)}>
                                                <i className="bx bx-info-circle me-1"></i>
                                            </button>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
}
